import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { createCustomTheme, projectPrimaryColors } from '../styles/theme';

/**
 * Custom hook to determine the appropriate theme based on the current route
 * @returns {Object} MUI theme object
 */
export const useRouteTheme = () => {
  const location = useLocation();
  
  const theme = useMemo(() => {
    const path = location.pathname;
    
    // Extract the route key from pathname (e.g., "/swing-vision" -> "swing-vision")
    const routeKey = path.substring(1); // Remove leading slash
    
    // Get the primary color for this route, default to #1E52F3
    const primaryColor = projectPrimaryColors[routeKey] || projectPrimaryColors.default;
    
    return createCustomTheme(primaryColor);
  }, [location.pathname]);
  
  return theme;
};
